export interface PaymentModeAdditionalInfoCriteria {

    invoiceAmount: number | null,
    shippingAgent: string | null,
    observation: string | null,
    customsDeclarationNo: string | null,
    customsDeclarationDate: Date | null,
    agentDeliveryDate: Date | null,
    docHdrId: number | null,
    draftInvoiceNo: string | null

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_PAYMENT_MODE_ADDITIONAL_INFO_CRITERIA: PaymentModeAdditionalInfoCriteria = {

    invoiceAmount: null,
    shippingAgent: null,
    observation: null,
    customsDeclarationNo: null,
    customsDeclarationDate: null,
    agentDeliveryDate: null,
    docHdrId: null,
    draftInvoiceNo: null,
}